/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_View_DetailInputs */

const vi_cdo_view_detail = /** @type {(inputs: Cdo_View_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem chi tiết`)
};

/**

* @param {Cdo_View_DetailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_view_detail = /** @type {((inputs?: Cdo_View_DetailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_View_DetailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_view_detail(inputs)
});